import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { APP_CONFIG } from 'app/core/config/app-config.constants';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TranslocoModule } from '@ngneat/transloco';
import { Error404Component } from './pages/error-404/error-404.component';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { cookieConfig } from './cookieConfig';
import { GoogletagService } from './core/googletag/googletag.service';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [MaintenanceComponent, PrivacyPolicyComponent, Error404Component],
    imports: [
        AppComponent,
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        CoreModule,
        TranslocoModule,
        LayoutModule,
        MatSnackBarModule,
        MarkdownModule.forRoot({}),
        NgcCookieConsentModule.forRoot(cookieConfig)
    ],
    providers: [
        { provide: APP_CONFIG, useValue: appConfig },
        GoogletagService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
    // constructor(service: ApmService) {
    //     service.init({
    //         serviceName: 'enoll-client',
    //         serverUrl: 'http://accellup.med.auth.gr:8200',
    //         distributedTracingOrigins: [environment.apiUrl]
    //     });
    // }
}
